import type { HealthScoreSpec } from '../../productintel/framework';
import { cn } from '../../lib/cn';

type Props = {
  scores?: HealthScoreSpec[];
};

function scoreColor(score: number) {
  if (score >= 85) return 'border-success-200 bg-success-50 text-success-700 dark:border-success-900 dark:bg-success-950 dark:text-success-300';
  if (score >= 70) return 'border-warning-200 bg-warning-50 text-warning-700 dark:border-warning-900 dark:bg-warning-950 dark:text-warning-300';
  return 'border-error-200 bg-error-50 text-error-700 dark:border-error-900 dark:bg-error-950 dark:text-error-300';
}

function trendIcon(trend?: string) {
  if (trend === 'up') return '↑';
  if (trend === 'down') return '↓';
  return '→';
}

export function ProductHealthGrid({ scores = [] }: Props) {
  return (
    <div className="grid gap-2 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      {scores.map((s) => (
        <div
          key={s.dimension}
          className={cn('rounded-lg border p-3 text-center', scoreColor(s.score))}
        >
          <p className="text-2xl font-semibold">{s.score}</p>
          <p className="mt-0.5 text-xs font-medium">{s.label}</p>
          {s.trend && (
            <p className="mt-1 text-xs opacity-70">{trendIcon(s.trend)} {s.trend}</p>
          )}
        </div>
      ))}
    </div>
  );
}
